<mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav-content>
        <mat-toolbar class="toolbar-main px-5 py-2" autosize>
            <app-toolbar class="w-100"></app-toolbar>
        </mat-toolbar>
        <div class="container-page">
            <app-navbar ></app-navbar>
            <router-outlet></router-outlet>
        </div>
        <app-footer class="w-100"></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
